document.addEventListener("DOMContentLoaded", function () {
    // 📌 Inicializar WaveSurfer para la pista principal
    const wavesurfer = WaveSurfer.create({
        container: "#waveform",
        waveColor: "white",
        progressColor: "red",
        cursorColor: "transparent",
        barWidth: 2,
        responsive: true,
        height: 80,
        backend: 'MediaElement',
        preload: 'auto',
        autoplay: false
    });

    // Precargar la pista principal
    wavesurfer.load("https://cdn.shopify.com/s/files/1/0914/1387/2946/files/mashup_demon_detropolis.mp3?v=1752083252");

    // Botón Play/Pause principal
    const playPauseBtn = document.getElementById("playPauseBtn");
    playPauseBtn.addEventListener("click", () => {
        if (wavesurfer.isPlaying()) {
            wavesurfer.pause();
            playPauseBtn.textContent = "▶";
        } else {
            wavesurfer.play();
            playPauseBtn.textContent = "⏸";
        }
    });

    // 🔥 Lista de muestras de audio con precarga mejorada
    const samples = [
        { id: "waveform1", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/BEAT_2.mp3?v=1752091455" },
        { id: "waveform2", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/MELODIA_1_31e31f69-fd64-45d4-8c11-26c06f685475.mp3?v=1752091455" },
        { id: "waveform3", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/BEAT_1.mp3?v=1752091455" },
        { id: "waveform4", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/MELODIA_3_deb49cee-4745-48b3-a944-f7197c39884a.mp3?v=1752091455" },
        { id: "waveform5", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/STEMS_2.mp3?v=1752091455" },
        { id: "waveform6", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/MELODIA_4_8f8fe640-b9ee-4f44-8ab9-0e8ae614c914.mp3?v=1752091455" },
        { id: "waveform7", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/MELODIA_2_f8236018-5945-45f9-8dfa-7609dda64998.mp3?v=1752091455" },
        { id: "waveform8", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/STEMS_1.mp3?v=1752091455" },
        { id: "waveform9", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/DRUM_LOOP_4.mp3?v=1752091455" },
        { id: "waveform10", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/DRUM_LOOP_2.mp3?v=1752091455" },
        { id: "waveform11", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/DRUM_LOOP_3.mp3?v=1752091455" },
        { id: "waveform12", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/DRUM_LOOP_1.mp3?v=1752091455" },
        { id: "waveform13", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/PHRASES_2.mp3?v=1752091455" },
        { id: "waveform14", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/ACCENTS_1.mp3?v=1752091454" },
        { id: "waveform15", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/FXs_1.mp3?v=1752091455" },
        { id: "waveform16", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/PHRASES_1.mp3?v=1752091454" },
        { id: "waveform17", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/Sonnity_-_Assassin_-_182_BPM_C_Min.wav?v=1739400714" },
        { id: "waveform18", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/Sonnity_-_Drift_-_170_BPM_E_Min.wav?v=1739400744" },
        { id: "waveform19", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/Sonnity_-_Retail_-_177_BPM_C_Min.wav?v=1739400815" },
        { id: "waveform20", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/Sonnity_-_Tripp_-_174_BPM_G_Min.wav?v=1739400854" },
        { id: "waveform21", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/DRUM_KIT_MUESTRA.wav?v=1739398985" },
        { id: "waveform22", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/Sonnity_-_808_Crime_C.wav?v=1739401079" },
        { id: "waveform23", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/Sonnity_-_Snare_TalkShow.wav?v=1739401211" },
        { id: "waveform24", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/DRUM_KIT_MUESTRA_2.wav?v=1739401746" },
        { id: "waveform25", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/Sonnity_-_PHRASE_Avenue_102_BPM_D_Min.wav?v=1752079747" },
        { id: "waveform26", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/Sonnity_-_PHRASE_Boulevard_160_BPM_F_Min.wav?v=1739401414" },
        { id: "waveform27", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/Sonnity_-_PHRASE_Park_Avenue_174_BPM_G_Min.wav?v=1739401522" },
        { id: "waveform28", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/Sonnity_-_PHRASE_Rent_-_182_BPM_B_Min.wav?v=1752079962" },
        { id: "waveform29", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/KEYS_-_Getaway.wav?v=1739407685" },
        { id: "waveform30", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/BELL_-_Forgery.wav?v=1739407685" },
        { id: "waveform31", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/BASS_-_Multiplayer.wav?v=1739407685" },
        { id: "waveform32", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/BELL_-_Falsification.wav?v=1739407685" },
        { id: "waveform33", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/Sonnity_-_Legal_MIDI_-_D_Min.wav?v=1739400535" },
        { id: "waveform34", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/Sonnity_-_City_MIDI_-_B_Min.wav?v=1739400535" },
        { id: "waveform35", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/Sonnity_-_Innovation_MIDI_-_E_Min.wav?v=1739400535" },
        { id: "waveform36", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/Sonnity_-_Skyline_MIDI_-_D_Min.wav?v=1739400535" },
        { id: "waveform37", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/BEAT_CURSO_MELODY.wav?v=1739397751" },
        { id: "waveform38", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/BEAT_CURSO.mp3?v=1739397751" },
        { id: "waveform39", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/Sonnity_-_Lilith_-_130_BPM_G_Min.wav?v=1747351139" },
        { id: "waveform40", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/Sonnity_-_Asmodeus_-_144_BPM_D_Min.wav?v=1747351139" },
        { id: "waveform41", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/Sonnity_-_ACCENT_Tabernacle_-_174_BPM_D_Min.wav?v=1747351163" },
        { id: "waveform42", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/Sonnity_-_808_Crushing_C.wav?v=1747351359" },
        { id: "waveform43", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/Sonnity_-_BASS_Deceit_C.wav?v=1747351583" },
        { id: "waveform44", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/Sonnity_-_BASS_Unholy_C.wav?v=1747351583" },
        { id: "waveform45", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/Sonnity_-_DONK_Curse_C.wav?v=1747351693" },
        { id: "waveform46", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/Sonnity_-_REESE_Inverted_Cross_C.wav?v=1747351704" },
        { id: "waveform47", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/Sonnity_-_808_MIDI_Fear_-_184_BPM_F_Min.wav?v=1747351884" },
        { id: "waveform48", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/Sonnity_-_808_MIDI_La_H_-_146_BPM_A_Min.wav?v=1747351884" },
        { id: "waveform49", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/Sonnity_-_Hihat_MIDI_Slow_-_120_BPM.wav?v=1747351884" },
        { id: "waveform50", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/Sonnity_-_Hihat_MIDI_Broly_-_133_BPM.wav?v=1747351884" },
        { id: "waveform51", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/Sonnity_-_Drum_Loop_1_-_164_BPM_D_Min.wav?v=1747351520" },
        { id: "waveform52", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/Sonnity_-_Drum_Loop_5_-_165_BPM_E_Min.wav?v=1747351519" },
        { id: "waveform53", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/Sonnity_-_Drum_Loop_8_-_153_BPM_E_Min.wav?v=1747351519" },
        { id: "waveform54", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/Sonnity_-_Drum_Loop_14_-_135_BPM_D_Min.wav?v=1747351533" },
        { id: "waveform55", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/DEMON_MODE_flp_1.mp3?v=1747353379" },
        { id: "waveform56", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/DETROIT_DEMON.mp3?v=1747353538" },
        { id: "waveform57", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/EPIC_DEMON_flp.mp3?v=1747353366" },
        { id: "waveform58", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/EPIC_DEMON_MODE_flp_4.wav?v=1747353386" },
        { id: "waveform59", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/DRILL_SECCION.mp3?v=1747352275" },
        { id: "waveform60", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/BEAT_ELADIO_CURSO_TRAP.mp3?v=1747352383" },
    ];

    const wavesurfers = {};

    // 📌 Inicializar WaveSurfer para todos los samples
    samples.forEach(sample => {
        wavesurfers[sample.id] = WaveSurfer.create({
            container: `#${sample.id}`,
            waveColor: "white",
            progressColor: "red",
            cursorColor: "transparent",
            barWidth: 2,
            responsive: true,
            height: 40,
            backend: 'MediaElement',
            preload: 'auto'
        });

        // ✅ Cargar la forma de onda de una vez
        wavesurfers[sample.id].load(sample.file);
    });

    // 🎵 Botones de reproducción
    document.querySelectorAll(".play-btn").forEach(btn => {
        btn.addEventListener("click", function () {
            const sampleContainer = this.closest(".sample");
            const waveformDiv = sampleContainer.querySelector(".waveform");
            const waveformId = waveformDiv.id;

            if (wavesurfers[waveformId].isPlaying()) {
                wavesurfers[waveformId].pause();
                this.textContent = "▶";
            } else {
                // Pausar todos los demás
                Object.keys(wavesurfers).forEach(id => wavesurfers[id].pause());
                document.querySelectorAll(".play-btn").forEach(b => (b.textContent = "▶"));

                wavesurfers[waveformId].play();
                this.textContent = "⏸";
            }
        });
    });

    // 📌 Función para abrir y cerrar preguntas frecuentes (FAQ)
    document.querySelectorAll(".faq-question").forEach(btn => {
        btn.addEventListener("click", function () {
            const answer = this.nextElementSibling;
            const toggleSign = this.querySelector(".faq-toggle");

            if (answer.style.maxHeight) {
                answer.style.maxHeight = null;
                answer.style.opacity = "0";
                toggleSign.textContent = "+";
            } else {
                // Cerrar todas las demás preguntas antes de abrir una
                document.querySelectorAll(".faq-answer").forEach(ans => {
                    ans.style.maxHeight = null;
                    ans.style.opacity = "0";
                });
                document.querySelectorAll(".faq-toggle").forEach(sign => (sign.textContent = "+"));

                answer.style.maxHeight = answer.scrollHeight + "px";
                answer.style.opacity = "1";
                toggleSign.textContent = "-";
            }
        });
    });
});
